// GoogleMapsConfig.js
export const libraries = ['places'];
